import { from, gql } from "@apollo/client";

// export * from "./projectManagement/projectManagement.mutation";

import {
  ADD_APPLICANT,
  APPLICANTS_BY_ORG,
  CREATE_APPLICANT,
  GET_APPLICANT_BY_ID,
  UPDATE_PERSONALAPPLICANT,
} from "./applicants/applicant.mutations";

import { CREATE_ASSET, GET_ASSET_BY_USERID } from "./asset/asset.mutation";
import { UPDATE_NOTIFICATION_SCHEDULE } from "./interview/interview.mutations";

import {
  CREATE_JOB,
  GET_JOB,
  GET_JOBS,
  JOB_PUBLIC,
  UPDATE_JOB,
} from "./jobs/jobs.mutations";
import {
  CREATE_PLACEMENT,
  GET_PLACEMENT_BY_ORG,
  UPDATE_PLACEMENT,
} from "./placement/placement.mutations";

import {
  APPROVAL_HIERARCHY_BY_ID,
  APPROVAL_HIERARCHY_BY_ORGID,
  CREATE_APPROVAL_HIERARCHY,
  DELETE_APPROVAL_HIERARCHY,
  UPDATE_APPROVAL_HIERARCHY,
} from "../mutations/approvalHierarchy/approvalHierarchy.mutation";

import {
  CLIENTS_BY_ORG,
  CREATE_CLIENT,
  CREATE_SUB_VENDOR,
  CREATE_VENDOR,
  UPDATE_CLIENT,
  UPDATE_SUB_VENDOR,
  UPDATE_VENDOR,
  VENDORS_BY_ORG,
} from "./prospect/prospect.mutations";

import {
  CREATE_BANKACCOUNT,
  GET_BANKACCOUNTDETAILS_BYUSER,
  UPDATE_BANKACCOUNT,
} from "./bankAccount/bankAccount.mutations";
import { UPDATE_CLAIM, UPDATE_MEDICALCLAIM } from "./claim/claim.mutation";

// Import Section start for attendance

// Import Section start for Education

// Import Section for Employee Compensation //

// Import section for Department
import {
  CREATE_DEPTS_AND_ROLES,
  DELETE_DEPARTMENT,
  GET_DEPTS,
  GET_DEPTS_BY_ORGID,
  GET_SCREENS_MAPPED_UNMAPPED_BY_ORGID,
  UPDATE_DEPTS_AND_ROLES,
} from "./common/department/department.mutation";

// Import section for Licenses
import { GET_LINCENSES } from "./common/license/license.mutation";
// Import Section EmployeeEducation //
import {
  CREATE_EMPLOYEEEDUCATION,
  DELETE_EMPLOYEEEDUCATION,
  GET_EMPLOYEEEDUCATION,
  UPDATE_EMPLOYEEEDUCATION,
} from "./employeeEducation/employeeEducation.mutation";

// Import Section EmployeeEmployment //
import {
  CREATE_EMPLOYEEEMPLOYMENT,
  DELETE_EMPLOYEEEMPLOYMENT,
  GET_EMPLOYEEEMPLOYMENT,
  UPDATE_EMPLOYEEEEMPLOYMENT,
} from "./employeeEmployment/employeeEmployment.mutation";

// Import Section for Employee Family Details //

import {
  CREATE_FAMILYDETAILS,
  DELETE_FAMILY_DETAILS,
  UPDATE_FAMILY_DETAILS,
} from "./employeeFamilyDetails/employeeFamilyDetails.mutation";

// Section for EmployeeUse Docs
import {
  CREATE_USERDOCS,
  GET_DOCS,
  UPDATE_USERDOCS,
} from "./employeeUserDocs/employeeUserDocs.mutation";

import {
  CREATE_EMPLOYEE_INSURANCE_DOCS,
  GET_EMPLOYEE_INSURANCE_DOCS,
  UPDATE_EMPLOYEE_INSURANCE_DOCS,
} from "./employeeInsuranceDocs/employeeInsuranceDocs.mutation";

//  Import Section for Employeement

// Import Section for Create Holiday //
import {
  UPDATE_GRATUITY,
  UPDATE_SETTLEMENT,
} from "./gratuity/gratuity.mutation";
import {
  CREATE_HOLIDAY_CALENDAR,
  GET_HOLIDAY_CALENDAR,
  GET_HOLIDAY_CALENDAR_BY_OFFICE,
  UPDATE_HOLIDAY_CALENDAR,
} from "./holidayCalendar/holidayCalendar.mutations";
// Section start for Invoice
import {
  CREATE_INVOICE,
  CREATE_INVOICE_ORG,
  DELETE_INVOICE,
  GET_INVOICE_BY_ID,
  GET_ORG_INVOICES,
  GET_INVOICE_ORG,
  UPDATE_INVOICE,
  SEND_INVOICE_EMAIL,
  GET_INVOICE_REPORTS,
} from "./inVoice/inVoice.mutation";

import {
  CREATE_INVOICE_PRODUCT_QUOTATION,
  DELETE_INVOICE_PRODUCT_QUOTATION_BY_ID,
  GET_ALL_INVOICE_PRODUCT_QUOTATIONS,
  GET_INVOICE_PRODUCT_QUOTATION_BY_ID,
} from "./inVoice/invoiceProductQuotation.mutation";
// Section start for Leave
import {
  CREATE_LEAVE_TYPE,
  DELETE_LEAVE_TYPE,
  GET_LEAVE_BY_STATUS,
  GET_LEAVE_TYPES_BY_ORG,
  GET_LEAVETYPES_COUNT,
  UPDATE_EACH_LEAVE_TYPE,
  UPDATE_LEAVE_TYPE,
  GET_EMPLOYEE__ALL_LEAVES_COUNT,
} from "./leaves/leaves.mutation";

// Section for Reports //

import {
  CREATE_TYPEOF_EMPLOYMENT,
  GET_TYPEOFEMPLOYMENT_BY_ORG,
  DELETE_TYPEOFEMPLOYMENT,
  UPDATE_TYPEOFEMPLOYMENT,
  GET_TYPEOFEMPLOYMENT_BY_ID,
} from "./typeofEmployment/typeofEmployment.mutations";

import { ALL_ASSIGNPERFORMANCE } from "./assignPerformance/assignPerformance.mutations";
import {
  ASSIGNED_PERFORMANCE_TEMPLATE,
  CREATE_PERFORMANCE,
  GET_PERFORMANCE,
  GET_PERFORMANCE_BY_ID,
  GET_PERFORMANCE_BY_IDS,
  UPDATE_PERFORMANCE,
} from "./performance/performance.mutations";

import {
  CREATE_EMPLOYEE_SURVEY,
  CREATE_SURVEY,
  GET_EMPLOYEE_SURVEY,
  GET_SURVEY,
  GET_SURVEYS_FOR_DROPDOWN,
  GET_SURVEY_BY_QUESTIONNAIRES,
  GET_SURVEY_QUESTIONNAIRES_BY_EMAIL_ID,
  UPDATE_SURVEY,
  DELETE_SURVEY,
  GET_SURVEY_BY_ID,
  CREATE_PUBLIC_SURVEY,
} from "./survey/survey.mutation";

// Section for Process //
import {
  CREATE_EMPLOYEE_SKILLS,
  GET_EMPLOYEE_SKILLS,
  UPDATE_EMPLOYEE_SKILLS_DETAILS,
} from "./employeeSkills/employeeSkills.mutation";

// Section starts for Users
import {
  CANCEL_RESIGNATION,
  CREATE_RESIGNATION,
  CREATE_USER,
  DELETE_USER,
  DELETE_USER_IN_ORG,
  GET_ALL_RESIGNATIONS,
  GET_ANNIVERSARY,
  GET_NEWEMPLOYEE_JOINING,
  GET_BIRTHDAYS,
  GET_EMPLOYEES,
  GET_MANAGERS,
  GET_REPORTTO,
  GET_REPORTTO_ALL_USERS,
  GET_RESIGNATION,
  GET_UPCOMING_BIRTHDAYS,
  GET_USER,
  GET_USER_BY_DEPT,
  GET_USER_BY_ID,
  GET_USER_BY_TOKEN,
  GET_USER_ORG_BY_USERID,
  GET_USERS,
  GET_USERS_DATA,
  RESEND_USER_WELCOME_MAIL,
  UPDATE_PASSWORD,
  UPDATE_PROFILE,
  UPDATE_USER,
  USER_LOGIN,
  ALL_PERMANENT_DELETEUSERS,
  GET_ALL_RESIGNATIONS_STATUS,
  UPDATE_RESIGNATION_STATUS,
  GET_EMPLOYEES_FOR_MANAGERS,
  GET_ACTIVE_EMPLOYEES_BY_DATE,
  GET_USERS_BY_DEPARTMENT_NAME,
  GET_USER_DATA_BY_EMAIL,
  RESET_PASSWORD,
} from "./users/users.mutation";

// Section start for Organization

import {
  CREATE_ORGANIZATION,
  CREATE_ORGANIZATION_USER,
  DELETE_ORGANIZATION,
  DELETE_ORGANIZATIONUSER,
  GET_ALL_ORGANIZATIONS,
  GET_ALL_USERORGANIZATIONS,
  GET_ORGANIZATIONBY_ID,
  GET_USER_ORGANIZATIONBY_ID,
  ORGANIZATION_LOGIN,
  ORGANIZATIONS_BY_SUBDOMAIN,
  RESEND_ORGANIZATION_EMAIL,
  UPDATE_ORGANIZATION,
  UPDATE_USER_ORGANIZATION,
  GET_ORGANIZATIONS,
  GET_POLICIES_AGREEMENT_ORG_DETAILS,
  GET_ORGANIZATION_DOMAIN_MAPPING_STATUS,
  RESEND_SUBSCRIPTION_EMAIL,
} from "./organization/organization.mutation";

import {
  CREATE_EXPERIENCELETTER,
  CREATE_OFFERLETTER,
  GET_EXPERIENCELETTER_BY_ORG,
  GET_OFFERLETTER_BY_ORG,
  UPDATE_OFFER_LETTER,
  GET_OFFERLETTER_BY_ID,
  DELETE_OFFER_LETTER,
  UPDATE__EXPERIENCE_LETTER,
  DELETE_EXPERIENCE_LETTER,
  GET_EXPERIENCELETTER_BY_ID,
  UPDATE__HIKE_LETTER,
  DELETE_HIKE_LETTER,
  GET_HIKELETTER_BY_ID,
  CREATE_HIKELETTER,
  GET_HIKELETTER_BY_ORG,
  GET_HIKELETTER_BY_USER_ID,
  CREATE_MEMBERSHIP_AGREEMENT_LETTER,
  DELETE_MEMBERSHIP_AGREEMENT_LETTER,
  GET_MEMBERSHIP_AGREEMENT_LETTER_BY_ID,
  GET_MEMBERSHIP_AGREEMENT_LETTER_BY_ORG,
  UPDATE_MEMBERSHIP_AGREEMENT_LETTER,
} from "./offerLetter/offerLetter.mutations";
import {
  CREATE_PAYROLL_TEMPLATE,
  CREATE_PAYROLL_TEMPLATE_US,
  GET_ALL_PAYROLL_TEMPLATES,
  GET_PAYROLL_TEMPLATE_BY_ID,
  GET_PAYROLL_TEMPLATE_OTHER_CALL,
  GET_PAYROLL_TEMPLATES_NAMES,
  Update_OTHER_ALLOWANCE_CAL,
  UPDATE_PAYROLL_COMPONENT,
  UPDATE_PAYROLL_TEMPLATE,
  UPDATE_PAYROLL_COMPONENT_US,
  DELETE_PAYROLL_TEMPLATE,
  DELETE_PAYROLL_COMPONENT,
} from "./payrollConfig/payrollConfig.mutation";
import {
  GET_PORTALROLE,
  UPDATE_PORTALROLE,
} from "./portalRole/portalRole.mutations";
import {
  CREATE_BOARD,
  CREATE_EMPLOYEE_PROJECT,
  CREATE_PROJECT,
  GET_ALL_EMPLOYEE_PROJECT_ROLES,
  GET_ALL_PROJECTS,
  GET_EMPLOYEE_PROJECT_ROLES,
  GET_PROJECT_BY_REPORTS,
  GET_PROJECT_ROLES,
  GET_PROJECTBY_ID,
  GET_TASKS_BY_USER,
  UPDATE_EMPLOYEE_PROJECTTEAM,
  UPDATE_PROJECT,
  UPDATE_PROJECTROLE,
  UPDATE_TASK,
  DELETE_PROJECT_SELECTED_EMPLOYEE,
  DELETE_PROJECT_ROLE,
  GET_PROJECT_SKILLS,
  GET_PROJECT_SUGGESTED_EMPLOYEES,
  GET_PROJECTS_BY_USER_ID,
} from "./projectManagement/projectManagement.mutation";

import {
  CREATE_POLICY,
  CREATE_TEMPLATE,
  GET_POLICY_BY_ORG,
  GET_TEMPLATE_BY_ORG,
  GET_TIMELINE_BY_ORG,
} from "./workflow/workflow.mutations";

import { GET_ALL_APPROVAL_DETAILS } from "./approvalDetails/approvalDetails.mutation";

import {
  CREATE_COMPENSATION,
  GET_USERBY_COMPENSATION,
  UPDATE_COMPENSATION,
  CREATE_US_COMPENSATION,
  UPDATE_US_COMPENSATION,
  GET_USERBY_COMPENSATION_US,
  DELETE_COMPENSATION,
  CREATE_IND_SINGLE_COMPENSATION,
  UPDATE_IND_SINGLE_COMPENSATION,
} from "./employeeCompensation/employeeCompensation.mutation";

import { GET_INDUSTRIES } from "./common/industry/industry.mutation";
import {
  CREATE_HEAD_OF_ORG,
  DELETE_ROLE,
  GET_ORG_ROLES,
  GET_ROLE_BY_ORG,
  GET_ROLES,
  GET_ROLE_BY_ROLEID,
} from "./common/role/role.mutations";
import {
  GET_SERVICES,
  CREATE_SERVICE,
} from "./common/services/services.mutations";

import {
  CREATE_NOTIFICATION,
  DASHBOARD_NOTIFICATION_ALL,
  GET_NOTIFICATION_BY_ID,
  GET_NOTIFICATION_BY_LATEST,
  GET_NOTIFICATION_BY_ORGID,
  UPDATE_NOTIFICATION,
} from "./notification/notification.mutation";

//  Exports Section Start form Here //
import {
  APPRECIATIONBY_DEPT,
  GET_ALL_APPRECIATION,
  GET_APPRECIATION,
} from "./appreciation/appreciation.mutation";

import {
  BOOK_DEMO,
  CONTACT_US,
  GET_BOOK_DEMO,
} from "./bookDemo/bookDemo.mutation";

import {
  CREATE_RESPONSE,
  GET_RESPONSE,
  UPDATE_RESPONSE,
} from "./performanceResponse/performanceResponse.mutation";

import { APPRAISAL } from "./appraisal/appraisal.mutation";
import {
  CREATE_CLIENT_EMAIL_CONFIG,
  GET_EMAIL_CONFIG_BY_ORG,
  UPDATE_EMAIL_CONFIG_SCREENS,
  GET_EMAIL_CONFIG_SCREENS_BY_ID,
  DELETE_EMAIL_CONFIG,
} from "./clientEmailConfig/clientEmailConfig.mutation";

import { GET_EMAIL_LOG_BY_ORG_AND_DATE } from "./emailLog/emailLog.mutation";

import {
  CREATE_HR_CONFIGS,
  GET_HR_CONFIGS,
  UPDATE_HR_CONFIGS,
} from "./HRconfigs/HRconfigs.mutations";
import { CREATE_BULKEMAIL } from "./orgBulkEmail";

import { GET_TASKTYPES } from "../mutations/common/taskType/taskType.mutation";

import {
  CREATE_TASKASSIGN,
  DELETE_TASKASSIGN,
  GET_TASKASSIGN_BY_ID,
  GET_TASTASSIGN,
  UPDATE_TASKASSIGN,
} from "../mutations/taskAssign/taskAssign.mutation";

import { RESIGNATION_APPROVAL_BY_ORG } from "../mutations/approvalHierarchy/approvalHierarchy.mutation";

import { GET_ORGANIZATION_CHART } from "../mutations/organizationChart/organizationChart.mutation";

import { GET_LOGS_BY_ORGID } from "../mutations/orgLogs/logs.mutations";

import {
  ANSWER_CHECKING,
  CREATE_PASSWORD_QUESTION,
  GET_PASSWORD_QUESTION_BY_EMAIL,
} from "../mutations/passWordQuestion/passWordQuestion.mutations";
import {
  CREATE_SIDEMENU,
  GET_ALLSIDEMENU,
  GET_SIDEMENU,
  UPDATE_SIDEMENU,
} from "../mutations/sideMenu/sideMenu.mutations";

import {
  CREATE_ERRORS,
  GET_ERRORREPORTS,
} from "./errorsLog/errorsLog.mutation";

import { GET_SCREEN } from "../mutations/screen/screen.mutation";

import {
  CREATE_WORK_FLOW_CONFIGURATION,
  GET_WORKFLOW_CONFIGURATION,
  GET_WORKFLOWCONFIGURATION_ONACESS,
  UPDATE_WORKfLOW_CONFIGURATION,
  UPDATE_MULTIPLE_WORKfLOW_CONFIGURATION,
} from "../mutations/workFlowConfiguration/workFlowConfiguration.mutation";

import { UPDATE_ASSIGNED_SHIFT } from "./roasterCongfiguration/roasterConfiguration.mutations";

import {
  CREATE_SALARY_ADVANCE,
  GET_SALARY_ADVANCE_BY_USERID,
  UPDATE_SALARY_ADVANCE,
  CANCEL_SALARY_ADVANCE,
  GET_SALARY_ADVANCE_BY_ID,
} from "./salaryAdvance/salaryAdvance.mutations";

import { CREATE_AUTHORIZED_SIGNATURE } from "./authorizedSignatures/authorizedSignatures.mutation";

import {
  GET_DAILY_RECEIPTS,
  GET_DONORS_REPORT,
  GET_BALANCE_SHEET,
  GET_DEVOTEE_BY_SEVA_TYPE_REPORTS,
  GET_TEMPLE_DASHBOARD_REPORTS,
  GET_BOOKING_SEVA_REPORTS,
} from "./templeReports/templeReports.mutations";

import {
  CREATE_COURSE,
  UPDATE_COURSE,
} from "../mutations/EmployementType/course/course.mutation";

import { CREATE_STUDENT_APPLICANT } from "../mutations/EmployementType/studentApplicant/studentApplicant.mutation";

import { CREATE_CONTACT_MANAGEMENT } from "../mutations/crm/contactManagement/contactManagement.mutations";

import { CREATE_ORDER } from "../mutations/inventoryManagement/order/order.mutations";

import { CREATE_SUPPLIER } from "../mutations/inventoryManagement/supplier/supplier.mutations";

import { CREATE_WAREHOUSE } from "../mutations/inventoryManagement/warehouse/warehouse.mutations";

import { CREATE_INVENTORY_MANAGEMENT } from "../mutations/inventoryManagement/inventoryManagement/inventoryManagement.mutation";

import {
  QUICK_ACCESS_BY_USER_ID,
  UPDATE_QUICK_ACCESS,
} from "./common/quickAccess/quickAccess.mutation";

import { CREATE_BIZ_CONTACT } from "./bizContacts/bizContacts.mutations";

import { CREATE_QUOTATION } from "./wasteManagement/quotation/quotation.mutation";

import { CREATE_MEMBERSHIP } from "./wasteManagement/membership/membership.mutation";

import {
  CREATE_VOUCHER,
  DELETE_VOUCHER_BY_ID,
  GET_ALL_VOUCHERS,
  GET_ALL_VOUCHERS_WITH_PAGINATION,
  GET_VOUCHER_BY_ID,
  APPROVE_VOUCHERS,
  REJECT_VOUCHERS,
} from "./vouchers/vouchers.mutations";

import { CREATE_BANK_STATEMENT } from "./bankStatements/bankStatement.mutations";

import { UPDATE_CRM_FORM } from "./crm/crmForm/crmForm.mutation";

import {
  GET_ALL_DONATION_TYPES,
  GET_DONATION_TYPE_BY_ID,
  CREATE_DONATION_TYPE,
  UPDATE_DONATION_TYPE,
  DELETE_DONATION_TYPE,
} from "./donationType/donationType.mutations";

import {
  CREATE_DONATION,
  UPDATE_DONATION,
  DELETE_DONATION,
  GET_ALL_DONATIONS,
  GET_DONATION_BY_ID,
  GET_DONATIONS_BY_RECEIPT_ID,
} from "./donation/donation.mutations";

import {
  GET_ALL_DONATION_ITEMS,
  GET_DONATION_ITEM_BY_ID,
  GET_DONATION_ITEMS_BY_DONATION_ID,
  CREATE_DONATION_ITEM,
  UPDATE_DONATION_ITEM,
  DELETE_DONATION_ITEM,
} from "./donationItem/donationItem.mutations";

import {
  GET_ALL_DEVOTEES,
  GET_DEVOTEE_BY_ID,
  CREATE_DEVOTEE,
  UPDATE_DEVOTEE,
  DELETE_DEVOTEE,
} from "./devotee/devotee.mutations";

import {
  CREATE_DEVOTEE_OCCASION,
  UPDATE_DEVOTEE_OCCASION,
  DELETE_DEVOTEE_OCCASION,
  GET_ALL_DEVOTEE_OCCASIONS,
  GET_DEVOTEE_OCCASION_BY_ID,
} from "./devoteeOccasion/devoteeOccasion.mutation";

import {
  GET_ALL_TEMPLES,
  GET_TEMPLE_BY_ID,
  GET_TEMPLE_BY_NAME,
  CREATE_TEMPLE,
  UPDATE_TEMPLE,
  DELETE_TEMPLE,
} from "./temple/temple.mutations";

import {
  GET_ALL_SEVA_SCHEDULES,
  GET_SEVA_SCHEDULE_BY_ID,
  GET_SEVA_SCHEDULES_BY_SEVA_TYPE_ID,
  CREATE_SEVA_SCHEDULE,
  UPDATE_SEVA_SCHEDULE,
  DELETE_SEVA_SCHEDULE,
} from "./sevaSchedule/sevaSchedule.mutations";

import {
  GET_ALL_SEVA_TYPES,
  GET_ALL_SEVA_TYPES_WITH_PAGINATION,
  GET_SEVA_TYPE_BY_ID,
  GET_SEVA_TYPES_BY_TEMPLE_ID,
  CREATE_SEVA_TYPE,
  UPDATE_SEVA_TYPE,
  DELETE_SEVA_TYPE,
} from "./sevaType/sevaType.mutations";

import {
  GET_ALL_RECEIPTS,
  GET_ALL_RECEIPTS_WITH_PAGINATION,
  GET_RECEIPT_BY_ID,
  GET_RECEIPTS_BY_TEMPLE,
  CREATE_RECEIPT,
  UPDATE_RECEIPT,
  DELETE_RECEIPT,
  GET_SWASWATA_ANNAPRASADA_RECEIPTS
} from "./receipt/receipt.mutations";

import {
  GET_POOJA_BOOKING_BY_ID,
  CREATE_POOJA_BOOKING,
  UPDATE_POOJA_BOOKING,
  DELETE_POOJA_BOOKING,
  GET_POOJA_BOOKINGS_BY_RECEIPT_ID,
  GET_ALL_POOJA_BOOKINGS,
  GET_ALL_POOJA_BOOKINGS_WITH_PAGINATION,
} from "./poojaBooking/poojaBooking.mutations";

import {
  GET_ALL_RECEIPT_ATTACHMENTS,
  GET_RECEIPT_ATTACHMENT_BY_ID,
  GET_ATTACHMENTS_BY_RECEIPT,
  CREATE_RECEIPT_ATTACHMENT,
  DELETE_RECEIPT_ATTACHMENT,
  UPDATE_RECEIPT_ATTACHMENT,
} from "./receiptAttachment/receiptAttachment.mutations";

export {
  CREATE_PAYROLL_TEMPLATE,
  CREATE_PAYROLL_TEMPLATE_US,
  GET_PAYROLL_TEMPLATE_BY_ID,
  GET_PAYROLL_TEMPLATE_OTHER_CALL,
  GET_PAYROLL_TEMPLATES_NAMES,
  GET_ALL_RECEIPT_ATTACHMENTS,
  UPDATE_RECEIPT_ATTACHMENT,
  GET_RECEIPT_ATTACHMENT_BY_ID,
  GET_ATTACHMENTS_BY_RECEIPT,
  CREATE_RECEIPT_ATTACHMENT,
  DELETE_RECEIPT_ATTACHMENT,
  GET_ALL_SEVA_TYPES,
  GET_ALL_SEVA_TYPES_WITH_PAGINATION,
  GET_SEVA_TYPE_BY_ID,
  GET_SEVA_TYPES_BY_TEMPLE_ID,
  CREATE_SEVA_TYPE,
  UPDATE_SEVA_TYPE,
  DELETE_SEVA_TYPE,
  GET_ALL_SEVA_SCHEDULES,
  GET_SEVA_SCHEDULE_BY_ID,
  GET_SEVA_SCHEDULES_BY_SEVA_TYPE_ID,
  CREATE_SEVA_SCHEDULE,
  UPDATE_SEVA_SCHEDULE,
  DELETE_SEVA_SCHEDULE,
  GET_ALL_TEMPLES,
  GET_TEMPLE_BY_ID,
  GET_TEMPLE_BY_NAME,
  CREATE_TEMPLE,
  UPDATE_TEMPLE,
  DELETE_TEMPLE,
  GET_DAILY_RECEIPTS,
  GET_DONORS_REPORT,
  GET_BALANCE_SHEET,
  GET_DEVOTEE_BY_SEVA_TYPE_REPORTS,
  GET_TEMPLE_DASHBOARD_REPORTS,
  GET_ALL_DEVOTEES,
  GET_DEVOTEE_BY_ID,
  CREATE_DEVOTEE,
  UPDATE_DEVOTEE,
  DELETE_DEVOTEE,
  GET_ALL_DONATION_TYPES,
  GET_DONATION_TYPE_BY_ID,
  CREATE_DONATION_TYPE,
  UPDATE_DONATION_TYPE,
  DELETE_DONATION_TYPE,
  ADD_APPLICANT,
  ALL_ASSIGNPERFORMANCE,
  ANSWER_CHECKING,
  APPLICANTS_BY_ORG,
  APPRAISAL,
  APPRECIATIONBY_DEPT,
  ASSIGNED_PERFORMANCE_TEMPLATE,
  BOOK_DEMO,
  CANCEL_RESIGNATION,
  CLIENTS_BY_ORG,
  CONTACT_US,
  CREATE_APPLICANT,
  CREATE_ASSET,
  CREATE_BANKACCOUNT,
  CREATE_BOARD,
  CREATE_BULKEMAIL,
  CREATE_CLIENT,
  CREATE_CLIENT_EMAIL_CONFIG,
  DELETE_EMAIL_CONFIG,
  GET_EMAIL_CONFIG_BY_ORG,
  UPDATE_EMAIL_CONFIG_SCREENS,
  GET_EMAIL_CONFIG_SCREENS_BY_ID,
  CREATE_COMPENSATION,
  CREATE_IND_SINGLE_COMPENSATION,
  UPDATE_IND_SINGLE_COMPENSATION,
  GET_USERBY_COMPENSATION_US,
  DELETE_COMPENSATION,
  CREATE_DEPTS_AND_ROLES,
  CREATE_EMPLOYEE_PROJECT,
  CREATE_EMPLOYEE_SKILLS,
  CREATE_EMPLOYEE_SURVEY,
  CREATE_PUBLIC_SURVEY,
  CREATE_EMPLOYEEEDUCATION,
  CREATE_EMPLOYEEEMPLOYMENT,
  CREATE_ERRORS,
  CREATE_EXPERIENCELETTER,
  CREATE_FAMILYDETAILS,
  CREATE_HEAD_OF_ORG,
  DELETE_ROLE,
  CREATE_HOLIDAY_CALENDAR,
  CREATE_HR_CONFIGS,
  CREATE_INVOICE,
  SEND_INVOICE_EMAIL,
  CREATE_INVOICE_ORG,
  CREATE_JOB,
  CREATE_LEAVE_TYPE,
  CREATE_NOTIFICATION,
  CREATE_OFFERLETTER,
  CREATE_ORGANIZATION,
  CREATE_ORGANIZATION_USER,
  CREATE_PASSWORD_QUESTION,
  CREATE_PERFORMANCE,
  CREATE_PLACEMENT,
  CREATE_POLICY,
  CREATE_PROJECT,
  CREATE_RESIGNATION,
  CREATE_RESPONSE,
  CREATE_SIDEMENU,
  CREATE_SUB_VENDOR,
  CREATE_SURVEY,
  CREATE_TASKASSIGN,
  CREATE_TEMPLATE,
  CREATE_USER,
  CREATE_USERDOCS,
  CREATE_VENDOR,
  CREATE_WORK_FLOW_CONFIGURATION,
  CREATE_INVOICE_PRODUCT_QUOTATION,
  DELETE_INVOICE_PRODUCT_QUOTATION_BY_ID,
  GET_ALL_INVOICE_PRODUCT_QUOTATIONS,
  GET_INVOICE_PRODUCT_QUOTATION_BY_ID,
  DASHBOARD_NOTIFICATION_ALL,
  DELETE_DEPARTMENT,
  DELETE_EMPLOYEEEDUCATION,
  DELETE_EMPLOYEEEMPLOYMENT,
  DELETE_FAMILY_DETAILS,
  DELETE_INVOICE,
  DELETE_LEAVE_TYPE,
  DELETE_ORGANIZATION,
  DELETE_ORGANIZATIONUSER,
  DELETE_TASKASSIGN,
  DELETE_USER,
  DELETE_USER_IN_ORG,
  GET_ALL_APPRECIATION,
  GET_ALL_EMPLOYEE_PROJECT_ROLES,
  GET_ALL_ORGANIZATIONS,
  GET_ALL_PAYROLL_TEMPLATES,
  GET_ALL_PROJECTS,
  GET_PROJECTS_BY_USER_ID,
  GET_ALL_RESIGNATIONS,
  GET_ALL_USERORGANIZATIONS,
  GET_ALLSIDEMENU,
  GET_ANNIVERSARY,
  GET_APPLICANT_BY_ID,
  GET_APPRECIATION,
  GET_ASSET_BY_USERID,
  GET_BANKACCOUNTDETAILS_BYUSER,
  GET_BIRTHDAYS,
  GET_DEPTS,
  GET_DEPTS_BY_ORGID,
  GET_DOCS,
  GET_EMPLOYEE_PROJECT_ROLES,
  GET_EMPLOYEE_SKILLS,
  GET_EMPLOYEE_SURVEY,
  GET_EMPLOYEEEDUCATION,
  GET_EMPLOYEEEMPLOYMENT,
  GET_EMPLOYEES,
  GET_EMPLOYEES_FOR_MANAGERS,
  GET_ACTIVE_EMPLOYEES_BY_DATE,
  GET_USERS_BY_DEPARTMENT_NAME,
  GET_USER_DATA_BY_EMAIL,
  GET_ERRORREPORTS,
  GET_EXPERIENCELETTER_BY_ORG,
  GET_HOLIDAY_CALENDAR,
  GET_HOLIDAY_CALENDAR_BY_OFFICE,
  GET_HR_CONFIGS,
  GET_INDUSTRIES,
  GET_INVOICE_BY_ID,
  GET_INVOICE_REPORTS,
  GET_ORG_INVOICES,
  GET_INVOICE_ORG,
  GET_JOB,
  GET_JOBS,
  GET_LEAVE_BY_STATUS,
  GET_LEAVE_TYPES_BY_ORG,
  GET_LEAVETYPES_COUNT,
  GET_LINCENSES,
  GET_MANAGERS,
  GET_NOTIFICATION_BY_ID,
  GET_NOTIFICATION_BY_LATEST,
  GET_NOTIFICATION_BY_ORGID,
  GET_OFFERLETTER_BY_ORG,
  GET_ORG_ROLES,
  GET_ORGANIZATION_CHART,
  GET_ORGANIZATIONBY_ID,
  GET_POLICIES_AGREEMENT_ORG_DETAILS,
  GET_ORGANIZATION_DOMAIN_MAPPING_STATUS,
  RESEND_SUBSCRIPTION_EMAIL,
  GET_PASSWORD_QUESTION_BY_EMAIL,
  GET_PERFORMANCE,
  GET_PERFORMANCE_BY_ID,
  GET_PERFORMANCE_BY_IDS,
  GET_PLACEMENT_BY_ORG,
  GET_POLICY_BY_ORG,
  GET_PORTALROLE,
  GET_PROJECT_BY_REPORTS,
  GET_PROJECT_ROLES,
  GET_PROJECTBY_ID,
  GET_REPORTTO,
  GET_REPORTTO_ALL_USERS,
  GET_RESIGNATION,
  GET_RESPONSE,
  GET_ROLE_BY_ORG,
  GET_ROLES,
  GET_SCREEN,
  GET_SCREENS_MAPPED_UNMAPPED_BY_ORGID,
  GET_SERVICES,
  CREATE_SERVICE,
  GET_SIDEMENU,
  GET_SURVEY,
  GET_SURVEYS_FOR_DROPDOWN,
  GET_SURVEY_BY_QUESTIONNAIRES,
  GET_SURVEY_QUESTIONNAIRES_BY_EMAIL_ID,
  GET_TASKASSIGN_BY_ID,
  GET_TASKS_BY_USER,
  GET_TASKTYPES,
  GET_TASTASSIGN,
  GET_TEMPLATE_BY_ORG,
  GET_TIMELINE_BY_ORG,
  GET_UPCOMING_BIRTHDAYS,
  GET_USER,
  GET_USER_BY_DEPT,
  GET_USER_BY_ID,
  GET_USER_BY_TOKEN,
  GET_USER_ORG_BY_USERID,
  GET_USER_ORGANIZATIONBY_ID,
  GET_USERBY_COMPENSATION,
  GET_USERS,
  GET_USERS_DATA,
  GET_WORKFLOW_CONFIGURATION,
  GET_WORKFLOWCONFIGURATION_ONACESS,
  JOB_PUBLIC,
  ORGANIZATION_LOGIN,
  ORGANIZATIONS_BY_SUBDOMAIN,
  RESEND_ORGANIZATION_EMAIL,
  RESEND_USER_WELCOME_MAIL,
  GET_ALL_APPROVAL_DETAILS,
  UPDATE_ASSIGNED_SHIFT,
  UPDATE_BANKACCOUNT,
  UPDATE_CLAIM,
  UPDATE_CLIENT,
  UPDATE_COMPENSATION,
  CREATE_US_COMPENSATION,
  UPDATE_US_COMPENSATION,
  UPDATE_DEPTS_AND_ROLES,
  UPDATE_EACH_LEAVE_TYPE,
  UPDATE_EMPLOYEE_PROJECTTEAM,
  UPDATE_EMPLOYEE_SKILLS_DETAILS,
  UPDATE_EMPLOYEEEDUCATION,
  UPDATE_EMPLOYEEEEMPLOYMENT,
  UPDATE_FAMILY_DETAILS,
  UPDATE_GRATUITY,
  GET_ROLE_BY_ROLEID,
  UPDATE_HOLIDAY_CALENDAR,
  UPDATE_HR_CONFIGS,
  UPDATE_INVOICE,
  UPDATE_JOB,
  UPDATE_LEAVE_TYPE,
  UPDATE_MEDICALCLAIM,
  UPDATE_NOTIFICATION,
  UPDATE_ORGANIZATION,
  Update_OTHER_ALLOWANCE_CAL,
  UPDATE_PASSWORD,
  UPDATE_PERFORMANCE,
  UPDATE_PERSONALAPPLICANT,
  UPDATE_PLACEMENT,
  UPDATE_PORTALROLE,
  UPDATE_PROFILE,
  UPDATE_PROJECT,
  UPDATE_PROJECTROLE,
  UPDATE_RESPONSE,
  UPDATE_SETTLEMENT,
  UPDATE_SIDEMENU,
  UPDATE_SUB_VENDOR,
  UPDATE_SURVEY,
  UPDATE_TASK,
  UPDATE_TASKASSIGN,
  UPDATE_USER,
  UPDATE_USER_ORGANIZATION,
  UPDATE_USERDOCS,
  UPDATE_VENDOR,
  UPDATE_WORKfLOW_CONFIGURATION,
  UPDATE_MULTIPLE_WORKfLOW_CONFIGURATION,
  USER_LOGIN,
  VENDORS_BY_ORG,
  ALL_PERMANENT_DELETEUSERS,
  DELETE_PROJECT_SELECTED_EMPLOYEE,
  DELETE_PROJECT_ROLE,
  UPDATE_OFFER_LETTER,
  GET_OFFERLETTER_BY_ID,
  DELETE_OFFER_LETTER,
  GET_ORGANIZATIONS,
  GET_PROJECT_SKILLS,
  GET_PROJECT_SUGGESTED_EMPLOYEES,
  CREATE_TYPEOF_EMPLOYMENT,
  GET_TYPEOFEMPLOYMENT_BY_ORG,
  UPDATE_NOTIFICATION_SCHEDULE,
  DELETE_SURVEY,
  GET_SURVEY_BY_ID,
  CREATE_AUTHORIZED_SIGNATURE,
  UPDATE__EXPERIENCE_LETTER,
  DELETE_EXPERIENCE_LETTER,
  GET_EXPERIENCELETTER_BY_ID,
  DELETE_TYPEOFEMPLOYMENT,
  UPDATE_TYPEOFEMPLOYMENT,
  GET_TYPEOFEMPLOYMENT_BY_ID,
  GET_LOGS_BY_ORGID,
  CREATE_SALARY_ADVANCE,
  GET_SALARY_ADVANCE_BY_USERID,
  GET_SALARY_ADVANCE_BY_ID,
  UPDATE_SALARY_ADVANCE,
  CANCEL_SALARY_ADVANCE,
  GET_BOOK_DEMO,
  GET_ALL_RESIGNATIONS_STATUS,
  UPDATE_RESIGNATION_STATUS,
  RESET_PASSWORD,
  CREATE_COURSE,
  RESIGNATION_APPROVAL_BY_ORG,
  CREATE_STUDENT_APPLICANT,
  UPDATE_COURSE,
  GET_NEWEMPLOYEE_JOINING,
  CREATE_CONTACT_MANAGEMENT,
  CREATE_ORDER,
  CREATE_SUPPLIER,
  CREATE_INVENTORY_MANAGEMENT,
  CREATE_WAREHOUSE,
  QUICK_ACCESS_BY_USER_ID,
  UPDATE_QUICK_ACCESS,
  UPDATE__HIKE_LETTER,
  DELETE_HIKE_LETTER,
  GET_HIKELETTER_BY_ID,
  CREATE_HIKELETTER,
  GET_HIKELETTER_BY_ORG,
  GET_EMPLOYEE__ALL_LEAVES_COUNT,
  GET_HIKELETTER_BY_USER_ID,
  CREATE_EMPLOYEE_INSURANCE_DOCS,
  GET_EMPLOYEE_INSURANCE_DOCS,
  UPDATE_EMPLOYEE_INSURANCE_DOCS,
  GET_EMAIL_LOG_BY_ORG_AND_DATE,
  CREATE_BIZ_CONTACT,
  CREATE_QUOTATION,
  CREATE_MEMBERSHIP,
  CREATE_VOUCHER,
  DELETE_VOUCHER_BY_ID,
  APPROVE_VOUCHERS,
  REJECT_VOUCHERS,
  GET_ALL_VOUCHERS,
  GET_ALL_VOUCHERS_WITH_PAGINATION,
  GET_VOUCHER_BY_ID,
  CREATE_BANK_STATEMENT,
  CREATE_MEMBERSHIP_AGREEMENT_LETTER,
  DELETE_MEMBERSHIP_AGREEMENT_LETTER,
  GET_MEMBERSHIP_AGREEMENT_LETTER_BY_ID,
  GET_MEMBERSHIP_AGREEMENT_LETTER_BY_ORG,
  UPDATE_MEMBERSHIP_AGREEMENT_LETTER,
  UPDATE_CRM_FORM,
  UPDATE_PAYROLL_COMPONENT,
  UPDATE_PAYROLL_TEMPLATE,
  UPDATE_PAYROLL_COMPONENT_US,
  DELETE_PAYROLL_TEMPLATE,
  DELETE_PAYROLL_COMPONENT,
  CREATE_DEVOTEE_OCCASION,
  UPDATE_DEVOTEE_OCCASION,
  DELETE_DEVOTEE_OCCASION,
  GET_ALL_DEVOTEE_OCCASIONS,
  GET_DEVOTEE_OCCASION_BY_ID,
  CREATE_POOJA_BOOKING,
  UPDATE_POOJA_BOOKING,
  DELETE_POOJA_BOOKING,
  GET_POOJA_BOOKINGS_BY_RECEIPT_ID,
  GET_ALL_POOJA_BOOKINGS,
  GET_ALL_POOJA_BOOKINGS_WITH_PAGINATION,
  GET_ALL_RECEIPTS,
  GET_ALL_RECEIPTS_WITH_PAGINATION,
  GET_RECEIPT_BY_ID,
  GET_RECEIPTS_BY_TEMPLE,
  CREATE_RECEIPT,
  UPDATE_RECEIPT,
  DELETE_RECEIPT,
  GET_SWASWATA_ANNAPRASADA_RECEIPTS,
  GET_POOJA_BOOKING_BY_ID,
  CREATE_DONATION,
  UPDATE_DONATION,
  DELETE_DONATION,
  GET_ALL_DONATIONS,
  GET_DONATION_BY_ID,
  GET_DONATIONS_BY_RECEIPT_ID,
  GET_ALL_DONATION_ITEMS,
  GET_DONATION_ITEM_BY_ID,
  GET_DONATION_ITEMS_BY_DONATION_ID,
  CREATE_DONATION_ITEM,
  UPDATE_DONATION_ITEM,
  DELETE_DONATION_ITEM,
  APPROVAL_HIERARCHY_BY_ID,
  APPROVAL_HIERARCHY_BY_ORGID,
  CREATE_APPROVAL_HIERARCHY,
  DELETE_APPROVAL_HIERARCHY,
  UPDATE_APPROVAL_HIERARCHY,
};

export const CREATE_CONTACT = gql`
  mutation CreateContact($input: createContact) {
    createContact(input: $input) {
      Id
    }
  }
`;
